import { ehEvento } from "@/constants/types/tipoTotem";

export default {
  // Carrega as molduras fixas do evento a partir do doc do totem.
  // Totem PADRAO (ou doc do totem ainda não recebido) → lista vazia, que é
  // exatamente o comportamento de sempre.
  // payload.force = true → refaz a leitura mesmo com a lista já carregada. É o
  // que a tela de escolha do tipo de foto usa no começo de cada compra, para o
  // franqueado poder trocar as molduras no meio do evento.
  async carregarMoldurasEvento({ commit, state, rootGetters }, payload) {
    const force = !!(payload && payload.force);
    const totem = rootGetters["totem/getTotem"] || {};
    const totemId = ehEvento(totem.tipoTotem) && totem.id ? totem.id : null;

    if (!totemId) {
      commit("setMolduras", { molduras: [], totemId: null });
      return;
    }

    if (!force && state.carregado && state.totemId === totemId) return;

    try {
      const { loadMoldurasEvento } = await import("@/service/firebase");
      const molduras = await loadMoldurasEvento(totemId);
      commit("setMolduras", { molduras, totemId });
    } catch (e) {
      console.error("Erro ao carregar as molduras do evento", e);
      // Falha de rede não pode derrubar a compra: sem lista, o totem cai no
      // comportamento normal (molduras globais, moldura opcional).
      if (!state.carregado) {
        commit("setMolduras", { molduras: [], totemId });
      }
    }
  },
};
